export const environment = {
  production: false,
  token: 'tryToCatchTheC4T',
  // URL: 'https://cris7ianback.net/api/',
  URL: 'http://localhost:3000/api/',
  fintocPublicKey: 'pk_live_oeCzyvyyyjxvY21aRHzmQz7vkdpVDpQ5z8RjQVzy2qY',

  auth: {
    tokenKey: 'auth_token',
    refreshTokenUrl: '/auth/refresh',
    loginUrl: '/auth/login',
    tokenRefreshThreshold: 300000, // 5 minutes in milliseconds
  },




};
